// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tableSimple":"_12CAmc","heading":"_1LEpzV","table":"yHredj","tr":"_1b9UkL","td":"_1xmRBD","th":"_1anGmo","thead":"_1yVVP4"};